import React from "react";
import styles from "./Style.module.css";
import { ArrowBackIos } from "@mui/icons-material";
import { Dialog, ButtonBase, Typography } from "@mui/material";
import history from "../../../libs/history.utils";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import useReportedSideEffectDetailHook from "./ReportedSideEffects.hook";
import capitalizeFirstLetter from "../../../hooks/CommonFunction";

const ReportedSideEffects = () => {
  const { data } = useReportedSideEffectDetailHook();

  const eventMapping = {
    SIDE_EFFECT: "Adverse Event / Side effect",
    PREGNANCY: "Pregnancy/lactation",
    EFFICACY: "Lack of efficacy",
    COMPLAINT: "Product complaint",
    PRODUCT_COMPLAINT: "Product complaint",
  };

  const formatText = (text) =>
    text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

  const ContentRenderer = (content) => {
    const formattedContent = content?.replace(/(?:\r\n|\r|\n)/g, "<br />");
    return <div dangerouslySetInnerHTML={{ __html: formattedContent }}></div>;
  };

  return (
    <div>
      <div className={styles.upperFlex}>
        <ButtonBase
          onClick={() => history.push("/reportedSideEffects")}
          sx={{ mb: 1 }}
        >
          <ArrowBackIos fontSize={"small"} />{" "}
          <span>
            <Typography variant={"h4"}>Reported Issue Detail</Typography>
          </span>
        </ButtonBase>
      </div>
      {data?.userObj && (
        <div className={styles.row}>
          <ShadowBox className={`${styles.report} ${styles.title}`}>
            <div className={styles.gridContainer}>
              <div className={styles.reporterDetails}>
                <Typography
                  variant={"h5"}
                  className={styles.reportHeading}
                  color={"text.primary"}
                  sx={{ mb: 1 }}
                >
                  {" "}
                  Reporter Details
                </Typography>

                <div className={styles.reportContent}>
                  <Typography variant="subtitle1" color={"text.primary"}>
                    {capitalizeFirstLetter(data?.userObj?.full_name) || "N/A"}
                  </Typography>
                  <Typography variant="body1" color={"text.secondary"}>
                    {data?.userObj?.full_contact || "N/A"}
                  </Typography>
                  <Typography variant="body1" color={"text.secondary"}>
                    {data?.userObj?.email || "N/A"}
                  </Typography>
                  {/* <Typography variant="body1" color={"text.secondary"}>
                    Relationship with Patient:{" "}
                    <strong>
                      {data?.reporter_relation
                        ? capitalizeFirstLetter(data?.reporter_relation)
                        : "N/A"}
                    </strong> 
                  </Typography>*/}
                  {/* <Typography variant="body1" color={"text.secondary"}>
                    Street Address:{" "}
                    <strong>
                      {data?.address
                        ? capitalizeFirstLetter(data?.address)
                        : "N/A"}
                    </strong>
                  </Typography>
                  <Typography variant="body1" color={"text.secondary"}>
                    City: <strong>{data?.city ? data?.city : "N/A"}</strong>
                  </Typography> */}
                  {/* <Typography variant="body1" color={"text.secondary"}>
                    ZIP / Postal Code:{" "}
                    <strong>{data?.zip ? data?.zip : "N/A"}</strong>
                  </Typography> */}
                </div>
              </div>
              <div className={styles.patientDetails}>
                <Typography
                  variant={"h5"}
                  className={styles.reportHeading}
                  color={"text.primary"}
                  sx={{ mb: 1 }}
                >
                  {" "}
                  Patient Details
                </Typography>

                <div className={styles.reportContent}>
                  <Typography variant="subtitle1" color={"text.primary"}>
                    {capitalizeFirstLetter(data?.patient_name)}
                  </Typography>
                  <Typography variant="body1" color={"text.secondary"}>
                    {data?.patient_age} yrs{" "}
                    {data?.patient_gender &&
                      data?.patient_gender !== "NA" &&
                      `(${capitalizeFirstLetter(data?.patient_gender)})`}
                  </Typography>
                  <Typography variant="body1" color={"text.secondary"}>
                    Reported On: <strong>{data?.createdAtText}</strong>
                  </Typography>
                  <Typography variant="body1" color={"text.secondary"}>
                    Client:{" "}
                    <strong>{capitalizeFirstLetter(data?.client_name)}</strong>
                  </Typography>
                  <Typography variant="body1" color={"text.secondary"}>
                    Program Name:
                    <strong>
                      {" "}
                      {capitalizeFirstLetter(data?.program_name)}
                    </strong>
                  </Typography>
                </div>
              </div>
            </div>
          </ShadowBox>
        </div>
      )}
      {(!data?.userObj || data?.userObj === "") && (
        <div className={styles.row}>
          <ShadowBox className={`${styles.report} ${styles.title}`}>
            <div className={styles.row}>
              <Typography
                variant={"h5"}
                className={styles.reportHeading}
                color={"text.primary"}
                sx={{ mb: 1, mr: 1 }}
              >
                {" "}
                Reporter Details
              </Typography>
              {/* <Typography
                variant={"h5"}
                className={styles.reportHeading}
                color={"text.secondary"}
                sx={{ mb: 1 }}
              >
                {" "}
                (Reporter is the patient experiencing the side effects)
              </Typography> */}
            </div>
            <div className={styles.gridContainer}>
              <div className={styles.reporterDetails}>
                <div className={styles.reportContent}>
                  <Typography variant="subtitle1" color={"text.primary"}>
                    {data?.patient_name ? capitalizeFirstLetter(data?.patient_name) : 'N/A'}
                  </Typography>
                  {/* <Typography variant="body1" color={"text.secondary"}>
                    {data?.patient_age} yrs{" "}
                    {data?.patient_gender &&
                      data?.patient_gender !== "NA" &&
                      `(${capitalizeFirstLetter(data?.patient_gender)})`}
                  </Typography> */}
                  <Typography variant="body1" color={"text.secondary"}>
                    {data?.country_code}-{data?.phone}
                  </Typography>
                  <Typography variant="body1" color={"text.secondary"}>
                    {data?.email}
                  </Typography>

                  {/* <Typography variant="body1" color={"text.secondary"}>
                    City: <strong>{data?.city ? data?.city : "N/A"}</strong>
                  </Typography> */}
                </div>
              </div>
              <div className={styles.patientDetails}>
                <div className={styles.reportContent}>
                  <Typography variant="body1" color={"text.secondary"}>
                    Reported On: <strong>{data?.createdAtText}</strong>
                  </Typography>
                  <Typography variant="body1" color={"text.secondary"}>
                    Client:{" "}
                    <strong>{capitalizeFirstLetter(data?.client_name)}</strong>
                  </Typography>
                  <Typography variant="body1" color={"text.secondary"}>
                    Program Name:
                    <strong>
                      {" "}
                      {capitalizeFirstLetter(data?.program_name)}
                    </strong>
                  </Typography>
                  {/* <Typography variant="body1" color={"text.secondary"}>
                    Street Address:{" "}
                    <strong>
                      {data?.address
                        ? capitalizeFirstLetter(data?.address)
                        : "N/A"}
                    </strong>
                  </Typography>
                  <Typography variant="body1" color={"text.secondary"}>
                    ZIP / Postal Code:{" "}
                    <strong>{data?.zip ? data?.zip : "N/A"}</strong>
                  </Typography> */}
                </div>
              </div>
            </div>
          </ShadowBox>
        </div>
      )}
      <div className={styles.container}>
        <ShadowBox className={styles.report}>
          <div className={styles.title}>
            <Typography
              variant={"h5"}
              className={styles.productHeading}
              color={"text.primary"}
              sx={{ marginTop: "-10px" }}
            >
              {" "}
              Issue Details
            </Typography>

            <div className={styles.reportContent}>
              <Typography
                variant="subtitle1"
                className={styles.medColor}
                sx={{ mt: 1 }}
              >
                {data?.medicine_name}
              </Typography>

              <Typography variant="body1" color={"text.secondary"}>
                Issue Type:
                <strong>
                  {Array.isArray(data?.issue_type)
                    ? data.issue_type
                      .map((event) =>
                        formatText(eventMapping[event] || event)
                      )
                      .join(", ")
                    : formatText(
                      eventMapping[data?.issue_type] ||
                      data?.issue_type ||
                      "N/A"
                    )}
                </strong>
              </Typography>

              {/* <Typography variant="body1" color={"text.secondary"}>
                Suspect Drug detail: <strong>{data?.drug ?? "N/A"}</strong>
              </Typography>
              <Typography variant="body1" color={"text.secondary"}>
                Symptoms:{" "}
                <strong>{capitalizeFirstLetter(data?.indication)}</strong>
              </Typography>
              <Typography variant="body1" color={"text.secondary"}>
                Dosage / Unit / Frequency:{" "}
                <strong> {capitalizeFirstLetter(data?.dosage)}</strong>
              </Typography> */}
              {/* <Typography variant="body1" color={"text.secondary"}>
                Route: <strong> {capitalizeFirstLetter(data?.route)}</strong>
              </Typography> */}
              <div className={styles.line} />
              <Typography variant="body1" color={"text.secondary"}>
                Issue Description
              </Typography>
              <Typography variant="body1" color={"text.secondary"}>
                <strong>{ContentRenderer(data?.issue_description)}</strong>
              </Typography>
              {/* <Typography variant="body1" color={"text.secondary"}>
                Event Description
              </Typography>
              <Typography variant="body1" color={"text.secondary"}>
                <strong>
                  {" "}
                  {capitalizeFirstLetter(data?.event_description)}
                </strong>
              </Typography> */}
              {data?.issue_type !== "SIDE_EFFECT" && (
                <div className={styles.attachments}>
                  <Typography variant="body1" color={"text.secondary"}>
                    Attachments
                  </Typography>
                  {data?.issue_images &&
                    data.issue_images.length > 0 &&
                    data.issue_images.map((val, index) => (
                      <a
                        key={index}
                        href={val}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={val}
                          crossOrigin="anonymous"
                          className={styles.issueImg}
                          alt={`Attachment ${index + 1}`}
                        />
                      </a>
                    ))}
                </div>
              )}
            </div>
          </div>
        </ShadowBox>
      </div>
      {/* <div className={styles.container}>
        <ShadowBox className={styles.report}>
          <div className={styles.title}>
            <Typography
              variant={"h5"}
              className={styles.productHeading}
              color={"text.primary"}
              sx={{ marginTop: "-10px", mb: 1 }}
            >
              {" "}
              Treatment Details
            </Typography>

            <div className={styles.reportContent}>
              <Typography variant="body1" color={"text.secondary"}>
                Duration:{" "}
                <strong>{`${data?.start_date_text} - ${data?.end_date_text}`}</strong>
              </Typography>
              <Typography variant="body1" color={"text.secondary"}>
                Lot/Batch Number:{" "}
                <strong>{capitalizeFirstLetter(data?.batch)}</strong>
              </Typography>
              <Typography variant="body1" color={"text.secondary"}>
                Expiry Date: <strong>{data?.expiry_date_text}</strong>
              </Typography>

              <div className={styles.line} />
              <Typography variant="body1" color={"text.secondary"}>
                Relevant Medical History
              </Typography>
              <Typography variant="body1" color={"text.secondary"}>
                <strong>
                  {" "}
                  {data?.medical_history
                    ? capitalizeFirstLetter(data?.medical_history)
                    : "Not available"}
                </strong>
              </Typography>
            </div>
          </div>
        </ShadowBox>
      </div> */}
    </div>
  );
};

export default ReportedSideEffects;
